// extracted by mini-css-extract-plugin
module.exports = {"container":"login_container__L6-sK","card":"login_card__1qYyf","logoSpotify":"login_logoSpotify__162gA","btnSpotify":"login_btnSpotify__2bUSY","login":"login_login__l0aAq"};